import React, { useState, useEffect } from 'react';
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones';
import { GetSettings, GetAdminParticipants } from './../../utilities/BL/Admin/Games/PluckingRooster';
import { PluckingRooster as PluckingRoosterOverlay } from './Overlays/PluckingRooster';

const PluckingRooster = ({ roomId: propRoomId }) => {
    const [messagesData, setMessagesData] = useState(null);
    const [connectionStatus, setConnectionStatus] = useState('idle');
    const [settings, setSettings] = useState(null);

    const searchParams = new URLSearchParams(window.location.search);
    const effectiveRoomId = propRoomId || searchParams.get('roomId');

    useEffect(() => {
        const originalBodyStyle = document.body.style.backgroundColor;
        const originalHtmlStyle = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root');

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) rootElement.style.backgroundColor = 'transparent';

        return () => {
            document.body.style.backgroundColor = originalBodyStyle;
            document.documentElement.style.backgroundColor = originalHtmlStyle;
            if (rootElement) rootElement.style.removeProperty('background-color');
        };
    }, []);

    const loadInitialSettings = async () => {
        try {
            const res = await GetSettings(effectiveRoomId);
            let merged = res?.success && res.data ? res.data : {};
            const partRes = await GetAdminParticipants(effectiveRoomId, '', 1, 10);
            if (partRes?.success && Array.isArray(partRes.data)) {
                merged = { ...merged, rankingList: partRes.data };
            }
            setSettings(merged);
        } catch (err) {
            console.error('[Overlay PluckingRooster] Error al cargar configuración inicial:', err);
        }
    };

    useEffect(() => {
        loadInitialSettings();

        const connect = async () => {
            await ConnectWebSocketForOverlay(
                'pluckingrooster', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay PluckingRooster] Toast:', msg),
                effectiveRoomId
            );

            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const typeLower = message.type.toLowerCase();
            if (typeLower === 'plucking_rooster' || typeLower === 'pluckingrooster' || typeLower === 'update_rankingpluckingrooster' || typeLower.startsWith('rooster.')) {
                setMessagesData(message);
            }
        };

        connect();

        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [effectiveRoomId]);

    return (
        <>
            <PluckingRoosterOverlay data={messagesData} initialSettings={settings} roomId={effectiveRoomId} />

            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: '2px 6px', fontSize: '10px', zIndex: 9999 }}>
                    WebSocket Disconnected
                </div>
            )}
        </>
    );
};

export { PluckingRooster };